import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { setTrustedBuyer } from '@/data/api/request/buyersRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSetTrustedUser() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: { userId: string; trusted: boolean }) => {
      await setTrustedBuyer(args);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.buyer.list] });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.buyer.details, variables.userId],
      });
      const msj = variables.trusted
        ? 'Todos los métodos de pago están ahora disponibles para el comprador.'
        : 'El comprador podrá realizar su pago exclusivamente con tarjeta.';
      showSnackSuccess(msj);
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });

  return mutation;
}
